export const getDurationFromSampleCount = (sampleCount) => sampleCount / 200;
